import React, { useEffect, useState } from 'react';
import moment from 'moment';
import IsLoadingBar from '../isLoading';
import { Modal, OverlayTrigger, Tooltip, Form, Button } from 'react-bootstrap';
import Auth from "../../Auth/Auth";
import AutoComplete from '../Util/AutoComplete';
import UPDRequest from './UPDRequest';
import UPDApprovals from './UPDApprovals';

import errorKittie from '../../images/11644-error-animation-entri-app.gif';
import './UPD.scss';

const auth = new Auth();
const unassigned = "Unassigned - Schedule to Upgrade";

const UPD = (props) => {
    const [ isApprover, setIsApprover ] = useState(false);
    const [ isLoading, setIsLoading ] = useState(true); 
    const [ isApprovalScreen, setIsApprovalScreen ] = useState(false);
    
    const [ showUPDRequestModal, setShowUPDRequestModal ] = useState(false);
    const [ showUPDModal, setShowUPDModal ] = useState(false); 
    const [ namespace, setNamespace ] = useState(""); 
    const [ searchQuery, setSearchQuery ] = useState(""); 
    const [ supportApp, setSupportApp ] = useState([]);
    const [ pendingClientChangeRequests, setPendingClientChangeRequests ] = useState([]);
    const [ availableWaves, setAvailableWaves ] = useState([]);
    const [ changeReasonArr, setChangeReasonArr ] = useState([]);

    useEffect(() => {
        setIsLoading(false);
        checkApprover();
    },[]);

    useEffect(() => {
        getDashboardSupportApp(props.UPDNamespace);
        setSearchQuery(props.UPDNamespace);
        setTimeout(function(){
            let search = document.querySelector("#autocomplete-namespace");
            if(search){
                search.value = props.UPDNamespace;
            }            
        },500);
        
    },[props.UPDNamespace]);

    const getDashboardSupportApp = async (namespace) => {
        setIsLoading(true);

        let accessToken = await auth.getToken();

        fetch('/api/getCurrentWave', {
            method : "GET",
            headers : {
                'Authorization': "Bearer " + accessToken,
                "namespace" : namespace
            }
        }).then(response => {
            if(response.status !== 200)
            {
                let payload = [{
                    status : response.status,
                    rawmsg : response.statusText,
                    cleanmsg : response.status + " was thrown with the message of " + response.statusText + " on " + response.url,
                    location: response.url,
                    timestamp : Date.now(),
                }];
                throw {
                    payload: payload,
                    error: new Error()
                  };
            }
            return  response.json();
        }).then(data => {
            console.log(data);
            setSupportApp(data);
        }).catch((error) => {
            window.apiError(error);
        });

        fetch('/api/getUPDdata', {
            method : "GET",
            headers : {
                'Authorization': "Bearer " + accessToken,
                "namespace" : namespace
            }
        }).then(response => {
            if(response.status !== 200)
            {
                let payload = [{
                    status : response.status,
                    rawmsg : response.statusText,
                    cleanmsg : response.status + " was thrown with the message of " + response.statusText + " on " + response.url,
                    location: response.url,
                    timestamp : Date.now(),
                }];
                throw {
                    payload: payload,
                    error: new Error()
                  };
            }
            return  response.json();
        }).then(data => {
            setPendingClientChangeRequests(data[1]);     
            setAvailableWaves(data[2]);   
            setChangeReasonArr(data[3]); 
            setIsLoading(false);
        }).catch((error) => {
            window.apiError(error);
        });
    };

    const checkApprover = async () => {
        let accessToken = await auth.getToken();

        fetch('/api/UPDApprover', {
            method : "GET",
            headers : {
                'Authorization': "Bearer " + accessToken
            }
        }).then(response => {
            if(response.status !== 200)
            {
                let payload = [{
                    status : response.status,
                    rawmsg : response.statusText,
                    cleanmsg : response.status + " was thrown with the message of " + response.statusText + " on " + response.url,
                    location: response.url,
                    timestamp : Date.now(),
                }];
                throw {
                    payload: payload,
                    error: new Error()
                  };
            }
            return  response.json();
        }).then(data => {
            if(data.length){
                setIsApprover(true);
            }
        }).catch((error) => {
            window.apiError(error);
        });        
    };
    
    const migrationDateLocal = (migrationDate) => {
        return migrationDate === unassigned ? unassigned : moment.utc(migrationDate).format('ll');
    };
    
    return (
        <div id="upd-pane">            
            <div className="smart-panel-title">
                {isApprover && (
                    <Button variant="link" className="float-right p-0 pr-2" onClick={() => setShowUPDRequestModal(true)}><small>See Pending Requests</small></Button>
                )}
                <div className="mb-0">
                    Upgrade Schedule
                    <OverlayTrigger
                        placement="top"
                        overlay={
                            <Tooltip>
                                Search for a namespace and request an upgrade date change
                            </Tooltip>
                        }>
                        <i className="far fa-question-circle tooltip-icon"></i>
                    </OverlayTrigger>                         
                </div>
                <div>
                    <span>Search for namespace</span>
                </div>                
                <div>
                    <AutoComplete  submit={(searchQuery) => { getDashboardSupportApp(searchQuery); setSearchQuery(searchQuery) }} />
                </div>                           
            </div>
            {isLoading ? 
                <IsLoadingBar />
                :
                <div>
                    {!supportApp.length && (
                        <div>
                            <img className="error-kittie" src={errorKittie} alt="no namespaces found with that name" />
                            <h6 className="no-namespace-wording ">No namespace found. Use the search bar above</h6>
                        </div>
                    )}
                    {supportApp.map(function (item, index) {
                        return (
                            <div key={index}>
                            <h4>{item.ClientName}</h4>
                            <h6 className="mb-3">{item.Namespace}</h6>
    
                            <p><strong>Release: </strong>{item.Release}</p>
                            <p><strong>Upgrade Wave: </strong>{item.Wave}</p>
                                <p><strong>Upgrade Date (Local): </strong>
                                {migrationDateLocal(item.MigrationDate_Local)}
                                {item.AllowChangeRequests === "TRUE" && (
                                    <>
                                        {pendingClientChangeRequests.length > 0 ?
                                            <OverlayTrigger
                                                placement="top"
                                                overlay={
                                                    <Tooltip>
                                                        Date Change Pending
                                                    </Tooltip>
                                                }>
                                                <Button variant="link" onClick={() => setShowUPDModal(true)}><i className="far fa-clock"></i></Button> 
                                            </OverlayTrigger> 
                                        :
                                            <OverlayTrigger
                                                placement="top"
                                                overlay={
                                                    <Tooltip>
                                                        Request Date Change
                                                    </Tooltip>
                                                }>
                                                <Button variant="link" onClick={() => setShowUPDModal(true)}><i className="far fa-edit"></i></Button> 
                                            </OverlayTrigger>
                                        }
                                    </>
                                )}                            
                            </p>
                            <p><strong>Client Upgrade Dashboard (BI):  <a className="BI_upd_link" href="https://app.powerbi.com/Redirect?action=OpenApp&appId=50989b1d-ee76-488e-8471-dc3b3e7123a8&ctid=289321e0-9db6-4644-b371-956e6056d9eb" target="_blank">Click here</a></strong></p>
                        </div>
                        )
                    })}
                    
                    {/* <div key={index}>
                        <h4>{item.ClientName}</h4>
                        <h6 className="mb-3">{item.Namespace}</h6>

                        <p><strong>Release: </strong>{item.Release}</p>
                        <p><strong>Upgrade Wave: </strong>{item.Wave}</p>
                        <p><strong>Upgrade Date (Local): </strong>
                            {migrationDateLocal(item.MigrationDate_Local)}
                            {item.AllowChangeRequests === "TRUE" && (
                                <>
                                    {pendingClientChangeRequests.length > 0 ?
                                        <OverlayTrigger
                                            placement="top"
                                            overlay={
                                                <Tooltip>
                                                    Date Change Pending
                                                </Tooltip>
                                            }>
                                            <Button variant="link" onClick={() => setShowUPDModal(true)}><i className="far fa-clock"></i></Button> 
                                        </OverlayTrigger> 
                                    :
                                        <OverlayTrigger
                                            placement="top"
                                            overlay={
                                                <Tooltip>
                                                    Request Date Change
                                                </Tooltip>
                                            }>
                                            <Button variant="link" onClick={() => setShowUPDModal(true)}><i className="far fa-edit"></i></Button> 
                                        </OverlayTrigger>
                                    }
                                </>
                            )}                            
                        </p>
                        <p><strong>Client Upgrade Dashboard (BI):  <a className="BI_upd_link" href="https://app.powerbi.com/Redirect?action=OpenApp&appId=f6edf4ec-c86b-49c7-9eb6-f3e126f6c7d1&ctid=289321e0-9db6-4644-b371-956e6056d9eb" target="_blank">Click here</a></strong></p>
                    </div>
                    )} */}
                   
                </div>
            }
            

            <Modal show={showUPDModal} onHide={() => setShowUPDModal(false)} dialogClassName="w-25 h-75 mx-auto active mt-5 mb-4" style={{ overflow: 'auto', marginBottom: "50px" }} animation={false}>
                {showUPDModal && (
                    <UPDRequest chosenSupportApp={supportApp} availableWaves={availableWaves} pendingChange={pendingClientChangeRequests} changeReasonArr={changeReasonArr} closeModal={() => { setShowUPDModal(false); setSupportApp([]); }} />                  
                )}                    
            </Modal>

            <Modal show={showUPDRequestModal} onHide={() => { setShowUPDRequestModal(false); setSupportApp([]); }} dialogClassName="w-25 h-75 m-auto active mt-4 mb-4" style={{ overflow: 'auto', marginBottom: "50px" }} animation={false} enforceFocus={false}>
                {showUPDRequestModal && (
                    <UPDApprovals />
                )}
            </Modal>
        </div>
   );

}

export default UPD;
